import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, CircularProgress, Box, Button, Typography, FormControl, FormLabel, FormHelperText } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Modal from '@mui/material/Modal';


import { toast } from 'react-toastify';

import { useDispatch, useSelector } from 'react-redux';
// components
import { clearError, forgetPassword, loadUser, login } from '../../../redux/actions/userAction';
import { FORGOT_PASSWORD_RESET } from '../../../redux/constants/userConstant';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------
const style = {
  position: 'absolute',
  top: '35%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  borderRadius: '0.4rem',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
export default function LoginForm({ user }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);
  const [email, setemail] = useState(null)
  const [password, setpassword] = useState(null)

  const { loading, isAuthenticated, error } = useSelector((state) => state.users)

  useEffect(() => {
    dispatch(loadUser())
  }, [dispatch])

  useEffect(() => {

    if (error) {
      toast.error(error)
      dispatch(clearError())
    }
    if (isAuthenticated) {
      // toast.success('Log in')
      navigate('/dashboard/app')
    }
    setemail(user?.email)

  }, [error, isAuthenticated, navigate, dispatch, user])

  const loginSubmitHandler = (e) => {
    e.preventDefault()
    dispatch(login(email, password))
  }

  // modal box 
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { loading: loadingForPass, message, error: errorForPass } = useSelector((state) => state.forgetPassword)

  useEffect(() => {
    if (errorForPass) {
      toast.error(errorForPass)
      dispatch(clearError())
    }
    if (message) {
      toast.success(message)
      dispatch({ type: FORGOT_PASSWORD_RESET })

      handleClose();
    }

  }, [message, errorForPass])

  const fogetPasswordSubmitHandler = (e) => {
    e.preventDefault()
    dispatch(forgetPassword(email))

  }

  return (
    <>
      <form action="" onSubmit={loginSubmitHandler}>
        <Stack spacing={3}>

          <FormControl>
            <TextField name="email"
              value={email}
              disabled
              onChange={e => setemail(e.target.value)}
              required label="" />
          </FormControl>

          <TextField
            name="password"
            label="Password"
            type={showPassword ? 'text' : 'password'}
            onChange={e => setpassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          {/* <Checkbox name="remember"label="Remember me" />  */}
          <Link variant="subtitle2" underline="hover" onClick={handleOpen}>
            Forgot password?
          </Link>
        </Stack>

        {loading ?

          (<LoadingButton fullWidth size="large" variant="text" >
            <CircularProgress color='success' />
          </LoadingButton>)
          :

          (<LoadingButton fullWidth size="large" type="submit" variant="contained" >
            Login
          </LoadingButton>)

        }
      </form>


      {/* modal code  */}
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Forget Password Request
            </Typography>
            <form action="" onSubmit={fogetPasswordSubmitHandler}>
              <Stack spacing={3} margin='1.5vmax 0'>

                <TextField name="email"
                  onChange={e => setemail(e.target.value)}
                  required label="Email address" />
              </Stack>

              {loadingForPass ?

                (<LoadingButton fullWidth size="large" variant="text" >
                  <CircularProgress color='success' />
                </LoadingButton>)
                :

                (<LoadingButton fullWidth size="large" type="submit" variant="contained" >
                  Request
                </LoadingButton>)

              }
            </form>
          </Box>
        </Modal>
      </div>
    </>
  );
}
